import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { LanguageAndConfigBoResponse } from '@utils/types/back-office/language-and-config.ts';
import { POST_URL } from '@utils/api/endpoints.ts';

interface UpdateLanguageConfigPayload {
  id?: number;
  bcp47: string;
  key: string;
  name: string;
  is_private?: boolean;
  is_enabled?: boolean;
  asr_url?: string;
  asr_model_location?: string;
  asr_audio_rate?: number;
  punctuation_url?: string;
  punctuation_model_location?: string;
  asr_version?: string;
  asr_common_version?: string;
  alignment_language_code?: string;
  alignment_version?: string;
  deepl_code?: string;
}

export const useUpdateLanguageAndConfig = (languageConfigId: number) => {
  const queryClient = useQueryClient();

  const updateLanguageAndConfig = async (
    payload: UpdateLanguageConfigPayload
  ) => {
    const response = await Axios.patch<LanguageAndConfigBoResponse>(
      `${POST_URL(languageConfigId.toString()).updateLanguageConfig}`,
      payload
    );
    return response.data;
  };

  return useMutation<
    LanguageAndConfigBoResponse,
    AxiosError<BaseError>,
    UpdateLanguageConfigPayload
  >(updateLanguageAndConfig, {
    onSuccess: () => {
      queryClient.invalidateQueries('languageAndConfig');
    },
    useErrorBoundary: false
  });
};
